import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@nexdel/core/auth';
import { ThemeProvider } from '@nexdel/core/hooks/use-theme';
import { Toaster } from '@nexdel/ui/components/sonner';
import { initI18n } from '@nexdel/core/i18n';
import { router } from './routes';

initI18n();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 1000 * 30, retry: 1 },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider app="supplier">
          <RouterProvider router={router} future={{ v7_startTransition: true }} />
          <Toaster />
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
